import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  position = "top-center",
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position={position}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#ee7203] group-[.toaster]:text-white group-[.toaster]:border-none group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-white",
          actionButton:
            "group-[.toast]:bg-white group-[.toast]:text-[#ee7203]",
          cancelButton:
            "group-[.toast]:bg-white/20 group-[.toast]:text-white",
          success: "group-[.toaster]:bg-[#ee7203] group-[.toaster]:text-white",
          error: "group-[.toaster]:bg-[#ee7203] group-[.toaster]:text-white",
          info: "group-[.toaster]:bg-[#ee7203] group-[.toaster]:text-white",
        },
        style: {
          background: '#ee7203',
          color: 'white',
          border: 'none',
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
